export type TBasket = {
  id: number;
  title: string;
  url: string;
  likes: number;
  rating: number;
  views: number;
  vote_count: number;
  isempty?: boolean;
  instruments: {
    code: string;
    title: string;
  }[];
  img: {
    src: string;
  };
  complexity: {
    level: 10 | 20 | 30;
    title: string;
  } | null;
  musicians: {
    title: string;
    url: string;
  }[];
  arrangement?: {
    id: string;
    title: string;
  };
  PRICE: {
    CURRENCY: string;
    PRINT_VALUE: string;
    VALUE: number;
    VARIANT: 'BASE' | 'MIDI';
  };
};

export type TBasketResponse = {
  data: TBasket[];
};
